// src/components/AccessCodeList.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';

function AccessCodeList() {
  const [codes, setCodes] = useState([]);

  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'accessCodes'));
        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCodes(list);
      } catch (error) {
        console.error('Feil ved henting av passord:', error);
      }
    };

    fetchCodes();
  }, []);

  return (
    <div className="mt-10">
      <h2 className="text-lg font-semibold mb-4 text-blue-700">Tilgangspassord</h2>
      <table className="w-full table-auto border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">#</th>
            <th className="border p-2">Passord</th>
            <th className="border p-2">Brukt</th>
            <th className="border p-2">Brukt av</th>
            <th className="border p-2">Dato</th>
          </tr>
        </thead>
        <tbody>
          {codes.map((code, index) => (
            <tr key={code.id} className="text-sm text-center">
              <td className="border p-2">{index + 1}</td>
              <td className="border p-2">{code.code}</td>
              <td className="border p-2">{code.used ? '✅' : '❌'}</td>
              <td className="border p-2">{code.usedBy || '-'}</td>
              <td className="border p-2">
                {code.timestampUsed
                  ? new Date(code.timestampUsed.seconds * 1000).toLocaleString()
                  : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AccessCodeList;
